import React from 'react'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/system'
import CustomAppBar from '../../components/CustomAppbar'
import { useMediaQuery, Divider } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { StyledToolbar } from '../../components/CustomAppbar/styles'
import { calculateAppbarOffset } from '../../utils/calculateAppbarOffset'

const PublicLayout: React.FC = (): JSX.Element => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.only('sm'))

  return (
    <Box display='flex' flexDirection='column' minHeight='100vh' marginTop={calculateAppbarOffset(theme, isMobile, isTablet)} paddingBottom={theme.spacing(10)}>
      <StyledToolbar isMobile={isMobile}>
        <CustomAppBar isPublic={true} />
        <Outlet />
        <Divider />
      </StyledToolbar>
    </Box>
  )
}

export default PublicLayout
